import React from 'react';
import tldToCountryCode from '@hydra/utils/tldToCountryCode';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import MapSvg from '@hydra/common/components/WorldMap/WorldMapSvg';
import { CriteriumSkeleton } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
    width: '100%'
  },
  svg: {
    fill: theme.palette.grey[300],
    display: 'block',
    width: '100%',
    height: 'auto'
  }
}));

interface Highlight {
  country: string
  value: number
}

interface WorldMapProps {
  highlights: Highlight[]
}

export default function WorldMap ({ highlights = [] }: WorldMapProps) {
  const classes = useStyles();
  const theme = useTheme();
  const mapCountryCodeToMapId = (code: string) => tldToCountryCode(code);

  const blueValue = (index: number) => {
    switch (index) {
      case 0:
        return theme.palette.primary.dark;
      case 1:
        return theme.palette.primary.main;
      case 2:
        return theme.palette.primary.medium;
      default:
        return theme.palette.primary.light;
    }
  };

  const makeStyles = (highlights: Highlight[]) => {
    return highlights
      .reduce(
        (styles, { country }, index) => {
          return {
            ...styles,
            [mapCountryCodeToMapId(country)]: {
              fill: blueValue(index)
            }
          };
        },
        {}
      );
  };

  const mapStyles = highlights.length > 0
    ? makeStyles(highlights)
    : {};

  const { variant } = useReviewContext();

  return (
    <div className={classes.root}>
      {
        variant === 'nocrit' ? <CriteriumSkeleton style={{ height: '250px' }} /> : <MapSvg className={classes.svg} style={mapStyles} />
      }
    </div>
  );
}
